import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { Icon } from '../icon';
import { CustomButton, Image, PopContainer, PopoverArea, MainContent } from './mixins'; // global time controls

var POP_TIMEOUT = 5000;
var DISMISSTIME = 300;
export var PopOverComponent = function PopOverComponent(_ref) {
  var children = _ref.children,
      imgSrc = _ref.imgSrc,
      content = _ref.content,
      visible = _ref.visible,
      onClose = _ref.onClose,
      arrowProps = _ref.arrowProps,
      fullwidth = _ref.fullwidth,
      id = _ref.id,
      _ref$autoHide = _ref.autoHide,
      autoHide = _ref$autoHide === void 0 ? true : _ref$autoHide;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dismissPop = _useState2[0],
      setDismissPop = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      timeIsUp = _useState4[0],
      setTimeIsUp = _useState4[1]; // volvemos todo los controladores a su estado default


  var handleTurnOff = function handleTurnOff() {
    onClose();
    setDismissPop(true);
    setTimeIsUp(false);
  };

  var _useState5 = useState(function () {
    return debounce(function () {
      return setTimeIsUp(true);
    }, POP_TIMEOUT);
  }),
      _useState6 = _slicedToArray(_useState5, 1),
      remainTime = _useState6[0];

  var _useState7 = useState(function () {
    return debounce(function () {
      handleTurnOff();
    }, DISMISSTIME);
  }),
      _useState8 = _slicedToArray(_useState7, 1),
      dissmisTime = _useState8[0];

  useEffect(function () {
    if (visible && !timeIsUp) {
      setDismissPop(false);

      if (autoHide) {
        remainTime();
      }
    }

    if (!visible || timeIsUp) {
      dissmisTime();
    }
  }, [autoHide, visible, timeIsUp]);
  return React.createElement(PopoverArea, {
    id: "popover-".concat(id),
    fullwidth: fullwidth
  }, children, !dismissPop && React.createElement(PopContainer, {
    isVisible: visible && !timeIsUp,
    setArrowPos: visible && !timeIsUp ? arrowProps : 'hide'
  }, imgSrc && React.createElement(Image, {
    src: imgSrc,
    alt: "Pop image alert"
  }), React.createElement(MainContent, null, content), React.createElement(CustomButton, {
    onClick: onClose,
    buttonoptions: {
      variant: 'black',
      size: 'medium',
      type: 'link'
    }
  }, React.createElement(Icon, {
    name: "icon-light-close",
    color: "#000018",
    size: "24"
  }))));
};